module.exports = __webpack_public_path__ + "img/anuj-nehra.9b0bc87e.jpg";